export class Subsidiary {
    SubsidiaryCompanyName: string;
    AddressLine1: string;
    AddressLine2: string;
    Number: string;
    EmailId: string;
    status: string;
    comments: string;
}
